module.exports = __webpack_public_path__ + "static/img/UTM老师_黑黑.16b89cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTM/UTM老师_黑黑.png
// module id = /E5z
// module chunks = 0